import type { ReactNode } from 'react';
import type { ResourceMap, ResourceName } from '@jarvis/shared';
import { useResource } from '../lib/useResource';
import { EmptyState, ErrorState, Skeleton, type EmptyProps, type SkeletonKind } from './ui';

interface Props<K extends ResourceName> {
  name: K;
  skeleton?: SkeletonKind;
  skeletonCount?: number;
  empty: EmptyProps;
  isEmpty?: (data: ResourceMap[K]) => boolean;
  compactError?: boolean;
  children: (data: ResourceMap[K]) => ReactNode;
}

/* Ciclo carregando → (vazio | conteúdo | erro) para um recurso da API. */
export function Resource<K extends ResourceName>({ name, skeleton, skeletonCount, empty, isEmpty, compactError, children }: Props<K>) {
  const { state, retry } = useResource(name);
  let body: ReactNode;
  if (state.status === 'loading') body = <Skeleton kind={skeleton} count={skeletonCount} />;
  else if (state.status === 'error') body = <ErrorState error={state.error} onRetry={retry} compact={compactError} />;
  else {
    const data = state.response.data;
    body = !data || isEmpty?.(data) ? <EmptyState {...empty} /> : children(data);
  }
  return <div aria-busy={state.status === 'loading'}>{body}</div>;
}
